import { render, staticRenderFns } from "./xtdzDetail.vue?vue&type=template&id=0c9eca89&scoped=true&"
import script from "./xtdzDetail.vue?vue&type=script&lang=js&"
export * from "./xtdzDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9eca89",
  null
  
)

export default component.exports